module.exports = __webpack_public_path__ + "img/03.9662ec55.jpg";